import { render, staticRenderFns } from "./Berthing.vue?vue&type=template&id=f0d76c0a&scoped=true"
import script from "./Berthing.vue?vue&type=script&lang=js"
export * from "./Berthing.vue?vue&type=script&lang=js"
import style0 from "./Berthing.vue?vue&type=style&index=0&id=f0d76c0a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f0d76c0a",
  null
  
)

export default component.exports